import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Upload,
    Modal,
    Form,
    Input,
    Avatar,
    Tag,
    DatePicker,
    InputNumber,
} from "antd";

import React, { useState, useEffect, useRef } from "react";
import { ToTopOutlined, ExclamationCircleOutlined, ExportOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import useDebounce from "../hooks/useDebounce";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import Customer from "../assets/images/customer.svg"
import Drivers from "../assets/images/drivers-license.svg"
import AllUser from "../assets/images/all-user.svg"
import * as XLSX from "xlsx";
import moment from "moment";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import axios from 'axios';
import iconRetinaUrl from '../assets/car_pin.png';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetinaUrl,
  iconUrl: iconRetinaUrl,
  shadowUrl: iconRetinaUrl,
});
function Home() {
   
    const [drivers, setDrivers] = useState([
     
      ]);
    // Fixing Leaflet's icon issue with React
   
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [dashbaordData, setDashboardData] = useState({
        totalUser: 0,
        totalCustomer: 0,
        totalDriver: 0,
        lastTrip: [],
        driverRequest: [],
    });
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);
    const debouncedSearchText = useDebounce(searchText, 300);
    const searchInput = useRef(null);
    const navigate = useNavigate();
    const { confirm } = Modal;



    const columns = [
        {
            title: "Customer Name",
            render: (_, { customerName }) => {
                return <div>{customerName ? customerName : '--'}</div>;
            },
        },
        {
            title: "Customer Contant",
            render: (_, { customerPhoneNumber, customerCountryCode }) => {
                return <div>{customerPhoneNumber ? customerCountryCode + "-" + customerPhoneNumber : '--'}</div>;
            },
        },
        {
            title: "Hotel Name",
            render: (_, { hotel }) => {
                return <div>{hotel ? hotel.name : '--'}</div>;
            },
        },
        {
            title: "Ride Type",
            render: (_, { rideType }) => {
                return <div>{rideType}</div>;
            },
        },
        {
            title: "Payment Type",
            render: (_, { paymentType }) => {
                return <div>{paymentType}</div>;
            },
        },
        {
            title: "Ride date",
            key: "created_at",
            dataIndex: "created_at",
            render: (_, { created_at }) => {
                return new Date(created_at).toLocaleDateString();
            },
        },

    ];
    const Drivercolumns = [
        {
            title: "Name",
            render: (_, { name, userName }) => {
                return <div>{name ? name : userName}</div>;
            },
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },

        {
            title: "Mobile Number",
            render: (_, { countryCode, mobileNumber }) => {
                return (
                    <div>
                        {countryCode ? "+" + countryCode : ''}-{mobileNumber ? mobileNumber : ''}
                    </div>
                );
            }
        },
        {
            title: "Registartion date",
            key: "created_at",
            dataIndex: "created_at",
            render: (_, { created_at }) => {
                return new Date(created_at).toLocaleDateString();
            },
        },

    ];


    useEffect(() => {
        request({
            url: `/admin/auth/dashbaord-data`,
            method: "GET",
            onSuccess: (data) => {
                console.log(data, "data");
                setDashboardData(data.data);
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    }, [refresh]);
    useEffect(() => {
        request({
            url: `/common/get-all-driver`,
            method: "GET",
            onSuccess: (data) => {
                console.log(data.data.data, "data");
                setDrivers(data.data.data);
                setLoading(false);
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    }, [refresh]);

    return (
        <Main>
            <div className="layout-content">
                <Row gutter={12}>

                    <Col span={24} md={8}>
                        <a href="/taxi-admin/user-manager">
                            <div className="home-cards">
                                <div className="home-card-inner">
                                    <div className="headding-card">
                                        <h4>All</h4>
                                    </div>
                                    <div className="card-counts">
                                        <h2>{dashbaordData.totalUser}</h2>
                                    </div>
                                </div>
                                <div class="icon">
                                    <img src={AllUser} />
                                </div>
                            </div>
                        </a>
                    </Col>


                    <Col span={24} md={8}>
                        <a href="/taxi-admin/user-manager">
                            <div className="home-cards">
                                <div className="home-card-inner">
                                    <div className="headding-card">
                                        <h4>Customers</h4>
                                    </div>
                                    <div className="card-counts">
                                        <h2>{dashbaordData.totalCustomer}</h2>
                                    </div>
                                </div>
                                <div class="icon">
                                    <img src={Customer} />
                                </div>
                            </div>
                        </a>
                    </Col>


                    <Col span={24} md={8}>
                        <a href="/taxi-admin/driver-manager">
                            <div className="home-cards">
                                <div className="home-card-inner">
                                    <div className="headding-card">
                                        <h4>Drivers</h4>
                                    </div>
                                    <div className="card-counts">
                                        <h2>{dashbaordData.totalDriver}</h2>
                                    </div>
                                </div>
                                <div class="icon">
                                    <img src={Drivers} />
                                </div>
                            </div>
                        </a>
                    </Col>

                </Row>
                <div className="tabled mt-3">
                    <Row>
                        <Col span={24} xl={24}>
                            <Card
                                bordered={false}
                                className="criclebox tablespace mb-24"
                                title="Last 20 Trips"
                            >
                                <div className="table-responsive">
                                    <Table
                                        loading={loading}
                                        columns={columns}
                                        dataSource={dashbaordData.lastTrip}
                                        pagination={false}
                                        className="ant-border-space"
                                    />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>

                <div className="tabled mt-3">
                    <Row>
                        <Col span={24} xl={24}>
                            <Card
                                bordered={false}
                                className="criclebox tablespace mb-24"
                                title="Driver pending authentication"

                            >
                                <div className="table-responsive">
                                    <Table
                                        loading={loading}
                                        columns={Drivercolumns}
                                        dataSource={dashbaordData.driverRequest}
                                        pagination={false}

                                        className="ant-border-space"
                                    />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>

                <div>
                <MapContainer center={[64.1012152, -21.8363638]} zoom={8} style={{ height: "100vh", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {drivers.length > 0 &&drivers.map(driver => (
        <Marker key={driver._id} position={[driver.latitude, driver.longitude]}>
          <Popup>
            <div>
              <h2>{driver.name}</h2>
              <p>{driver.address}</p>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
                </div>

            </div>
        </Main>
    );
}

export default Home;
